import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material';


const SalonThemeSections = ({
  sections,
  expandedKey,
  onExpandedChange,
  disabled = false,
}) => (
  <Box data-testid="salon-theme-sections">
    {sections.map((section) => (
      <Accordion
        key={section.key}
        expanded={expandedKey === section.key}
        onChange={() => {
          if (!disabled) onExpandedChange(section.key);
        }}
        disabled={disabled}
        disableGutters
        elevation={0}
        sx={{
          '&:before': { display: 'none' },
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:last-of-type': { borderBottom: 0 },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          id={`salon-theme-section-${section.key}`}
          aria-controls={`salon-theme-panel-${section.key}`}
          sx={{ minHeight: 60 }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            sx={{ width: '100%', pr: 1 }}
          >
            <Typography fontWeight={800}>{section.label}</Typography>
            {section.summary}
          </Stack>
        </AccordionSummary>
        <AccordionDetails
          id={`salon-theme-panel-${section.key}`}
          sx={{ px: 2, pb: 2.5 }}
        >
          {section.content}
        </AccordionDetails>
      </Accordion>
    ))}
  </Box>
);

export default SalonThemeSections;
